import { WalletIcon } from "@heroicons/react/24/outline";
import { FaSpinner } from "react-icons/fa6";

import { CreatableWallet } from "../../../utils/creatableWallets";
import Flag from "../../Flag";

interface WalletSetupProps {
  wallets: CreatableWallet[];
  creatingCurrency?: string | null;
  onCreate: (wallet: CreatableWallet) => void;
}

export default function WalletSetup({
  wallets,
  creatingCurrency,
  onCreate,
}: WalletSetupProps) {
  return (
    <div className="mx-auto w-full max-w-lg rounded-2xl bg-white p-6 md:p-8 shadow-sm">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-50 text-primary">
        <WalletIcon className="h-6 w-6" />
      </div>

      <h2 className="mt-4 text-xl font-semibold text-primary">
        Set up your wallets
      </h2>
      <p className="mt-1 text-sm text-gray-500">
        Create a wallet to start receiving and sending money. Your Naira wallet
        powers international transfers.
      </p>

      <div className="mt-6 space-y-3">
        {wallets.map((wallet) => {
          const isCreating = creatingCurrency === wallet.currency;
          return (
            <div
              key={wallet.currency}
              className="flex items-center gap-3 rounded-xl border border-gray-100 p-3"
            >
              <Flag currency={wallet.currency} className="h-8 w-8" />
              <div className="flex flex-col">
                <span className="flex items-center gap-2 font-medium text-gray-900">
                  {wallet.name}
                  {wallet.isPrimary && (
                    <span className="rounded-full bg-secondary/40 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-primary">
                      Recommended
                    </span>
                  )}
                </span>
                <span className="text-xs text-gray-400">{wallet.currency}</span>
              </div>

              <button
                type="button"
                disabled={isCreating}
                onClick={() => onCreate(wallet)}
                className="ml-auto inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-white hover:bg-primary/90 transition-colors disabled:opacity-60"
              >
                {isCreating && <FaSpinner className="h-4 w-4 animate-spin" />}
                {isCreating ? "Creating…" : "Create"}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
